export const IMAGE_UPLOAD_SIZE_LIMIT_MB = 15
export const IMAGE_UPLOAD_SIZE_LIMIT_BYTES = IMAGE_UPLOAD_SIZE_LIMIT_MB * Math.pow(10, 6)
